import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'qrcode';
import { api, type PlanView } from '../lib/api';
import { Wordmark } from '../components/Logo';

/** Printable counter card (A5) for the shop: QR + plans. Open, then print at 100%. */
export default function Print() {
  const { slug = '' } = useParams();
  const [d, setD] = useState<{ shop: { name: string; district: string | null }; plans: PlanView[] } | null>(null);
  const [qr, setQr] = useState('');
  useEffect(() => { api.get<{ shop: { name: string; district: string | null }; plans: PlanView[] }>(`/api/public/shops/${slug}`).then(setD); }, [slug]);
  useEffect(() => { QRCode.toDataURL(`${location.origin}/s/${slug}`, { margin: 0, width: 600, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#FDFAF0' } }).then(setQr); }, [slug]);
  if (!d) return null;
  return (
    <main className="min-h-dvh bg-white p-6 print:p-0">
      <style>{`@page { size: A5 portrait; margin: 8mm } @media print { .no-print { display: none } }`}</style>
      <div className="no-print mb-4 flex gap-2"><button className="btn btn-primary" onClick={() => window.print()}>اطبع</button><span className="muted text-sm self-center">A5، بلا تحجيم. ثبّتها بجانب المرآة أو على الكاشير.</span></div>
      <div className="mx-auto bg-paper text-ink rounded-[18px] border border-line p-7 grid gap-5" style={{ width: '148mm', minHeight: '200mm' }}>
        <div className="flex items-center justify-between"><Wordmark height={26} /><span className="text-sm muted">{d.shop.name}</span></div>
        <div>
          <div className="eyebrow">عضوية شهرية</div>
          <h1 style={{ fontSize: '2rem', lineHeight: 1.15 }}>ادفع أول الشهر، واحجز كرسيك كل مرة.</h1>
          <p className="muted mt-2">امسح الرمز بكاميرا جوالك، اختر باقتك، وتصلك بطاقتك على واتساب في أقل من دقيقة.</p>
        </div>
        <div className="grid grid-cols-5 gap-4 items-center">
          <div className="col-span-2">{qr && <img src={qr} alt="امسح للاشتراك" className="w-full rounded-md" />}</div>
          <ul className="col-span-3 grid gap-2">
            {d.plans.map((p) => (
              <li key={p.id} className="rounded-[12px] bg-white border border-line px-3 py-2 flex items-center justify-between">
                <div><div className="font-bold">{p.name}</div><div className="text-xs muted">{p.visits} {p.visits === 1 ? 'زيارة' : 'زيارات'}{p.includes_beard ? ' + ذقن' : ''}{p.window ? ' · صباحًا' : ''}</div></div>
                <div className="text-end"><div className="display num" style={{ fontSize: '1.4rem' }}>{p.price_label.split(' ')[0]}</div><div className="text-[10px] muted">{p.price_label.split(' ').slice(1).join(' ').replace('ريالًا', 'ريالًا شهريًا')}</div></div>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-auto text-xs muted flex items-center gap-2 border-t border-line pt-3"><Wordmark height={11} /> الزيارات لا تنتقل إلى الشهر التالي. الإلغاء من الدورة التالية، وحق العدول 7 أيام. العضوية لرقم جوال واحد.</div>
      </div>
    </main>
  );
}
